import {React, useState} from 'react';
import {Grid,Box, Button, Paper,Stack,FormControl,InputLabel, Select, MenuItem, Typography} from '@mui/material';
import {Preview, Add, Groups} from '@mui/icons-material';
import '../../App.css'
import axios from 'axios';
import { getYearList } from '../../services/yearList';
import HolidayMasterForm from './HolidayMasterForm';
import HolidayMasterTable from '../table-data/HolidayMasterTable';
import Popup from '../Popup';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';

function ViewHolidayMaster(){

    const [holidayYear, setHolidayYear] = useState(new Date());
    const [filteredHolidays, setFilteredHolidays] = useState([]);
    const [openPopup1, setOpenPopup1] = useState(false);
    const [openPopup2, setOpenPopup2] = useState(false);
    const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        setHolidayYear(e.target.value);
    }

    const filterHolidays = async (e) => {
        try{
            const filteredHolidays = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/company-master/holiday-master/filter/` + holidayYear);
            setFilteredHolidays(filteredHolidays.data);
            setOpenPopup2(true);
        } catch (e) {
          if(e.response.status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              navigate('/');
            },1000);
          }
        }
    }

  const handleSubmit = (e) => {
    e.preventDefault();
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", padding: "30px", fontWeight: "500px"}} >
      <Paper elevation={0} sx={{width: "700px"}}>
        <Grid className="form-title" container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>Holiday Master</Typography> </Grid>
          <Grid item> <Groups style={{marginLeft: "-30px"}} sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{margin: "30px"}}>

            <Stack direction={"row"} className="space-between">
                <Stack sx={{width: "250px"}}>
                <FormControl
                variant="outlined"
                >
                    <InputLabel>Holiday Year</InputLabel>
                    <Select
                    label="Holiday Year"
                    name="holidayYear"
                    size="small"
                    value={holidayYear}
                    onChange={handleInputChange}
                    >
                    <MenuItem value="">None</MenuItem>
                        {
                        getYearList().map(
                            item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                        )
                        }

                    </Select>
                </FormControl>
                </Stack>
                <div style={{justifyContent: "flex-end", gap: "10px"}}>
                <Button className="form-btn" variant="outlined" onClick={filterHolidays} startIcon={<Preview sx={{width: "30px", height: "30px"}}/>} >Show</Button>
                <Button className="form-btn" variant="outlined" color="success" onClick={()=>setOpenPopup1(true)} startIcon={<Add sx={{width: "30px", height: "30px"}}/>} >ADD</Button>
            </div>
            </Stack>

            <div style={{marginLeft: "70px", marginTop: "40px"}}><HolidayMasterTable  /></div>

            </Stack>
        </form>

        <Popup
          title="Add"
          openPopup={openPopup1}
          setOpenPopup={setOpenPopup1}
        >
          <HolidayMasterForm title="Add New Leave" />
        </Popup>

        {<Popup
          title="Add"
          openPopup={openPopup2}
          setOpenPopup={setOpenPopup2}
        >
          <HolidayMasterTable title="Add New Leave" yearSelected={"true"} filteredHolidays={filteredHolidays}/>
        </Popup>}
      </Paper>
      <Notification
            notify={notify}
            setNotify={setNotify} />
    </Box>
  )
}

export default ViewHolidayMaster;
